import { InvoiceExtractionPipeline } from "services/api/settings/invoiceExtraction/types";
import { CardSelectOption } from "ui/components/CardSelect";

/**
 * Načini čitanja računa, opisani onako kako se biraju na ekranu: što se stvarno događa s datotekom
 * i koji model radi posao. Iz istog popisa se čita i naziv polja za model, da ekran nikad ne nudi
 * dva modela odjednom kad se koristi samo jedan.
 */
export const PIPELINE_CHOICES = [
  {
    value: InvoiceExtractionPipeline.DIRECT,
    icon: "/media/icons/picture.svg",
    title: "Model čita stranicu",
    description:
      "Račun ide izravno modelu kao slika. Bolje čita stavke i tablice, ali ne zna reći gdje na stranici koji podatak stoji.",
    modelLabel: "Model koji gleda stranicu",
    steps: ["Datoteka", "Model", "Podaci"],
  },
  {
    value: InvoiceExtractionPipeline.OCR,
    icon: "/media/icons/text-search.svg",
    title: "Document AI pa model",
    description:
      "Google Document AI prvo pretvori stranicu u tekst s položajem svake riječi, a model iz tog teksta vadi podatke. Jeftinije je i može označiti podatke na dokumentu, ali slabije čita tablice stavki.",
    modelLabel: "Model koji tumači OCR tekst",
    steps: ["Datoteka", "Document AI", "Model", "Podaci"],
  },
];

/** Isti načini u obliku koji traži kartični odabir. */
export const PIPELINE_CARD_OPTIONS: CardSelectOption[] = PIPELINE_CHOICES.map(choice => ({
  id: choice.value,
  icon: choice.icon,
  title: choice.title,
  description: choice.description,
}));

/** Odabrani način, uz povratak na izravni put kad je spremljena nepoznata vrijednost. */
export const getPipelineChoice = (pipeline: string) =>
  PIPELINE_CHOICES.find((choice) => choice.value === pipeline) ?? PIPELINE_CHOICES[0];
